import classes from './Select.module.css'

//It's color changes on select is tested on PaperFormat/FormatEdit
const Select = ({children,value,className,...rest}) => {
  return (
    <select value={value} className={`${value === "" ? classes.selectDisabled : classes.select } ${className}`} {...rest}>{children}</select>
  )
}

export default Select
